(() => {
  if (window.UniNavigationV6) return;
  window.UniNavigationV6 = true;
  const instances = new Map();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const motion = () => !reduced.matches && document.body?.dataset.motion !== 'none' && document.body?.dataset.motionUser !== 'none' && !window.Shopify?.designMode;
  const syncMotion = () => { document.documentElement.dataset.uniVt = motion() ? 'on' : 'off'; };
  reduced.addEventListener('change', syncMotion);
  document.addEventListener('uni:motionchange', syncMotion);
  syncMotion();
  function initialize(scope = document) {
    scope.querySelectorAll('[data-refined-header]').forEach(header => {
      if (instances.has(header)) return;
      const abort = new AbortController(), opts = { signal: abort.signal };
      const fine = matchMedia('(min-width: 990px) and (hover: hover)');
      const previews = [...header.querySelectorAll('[data-nav-preview]')];
      let active = null, animation = null, leaveTimer = null;
      const hide = () => { clearTimeout(leaveTimer); animation?.cancel(); previews.forEach(item => { item.hidden = true; }); active = null; };
      const settle = () => { if (!motion()) { animation?.cancel(); animation = null; } };
      document.addEventListener('uni:motionchange', settle, opts);
      reduced.addEventListener('change', settle, opts);
      const show = trigger => {
        clearTimeout(leaveTimer);
        const panel = previews.find(item => item.id === trigger?.dataset.navPreviewTrigger);
        if (!panel || matchMedia('(max-width: 989px)').matches) { hide(); return; }
        if (active === panel) return;
        hide(); panel.hidden = false; active = panel;
        if (motion() && panel.animate) animation = panel.animate([{ opacity: 0, transform: 'translateY(-6px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 190, easing: 'cubic-bezier(.2,.7,.2,1)' });
      };
      header.querySelectorAll('.uni-nav > a').forEach(link => {
        link.addEventListener('pointerenter', () => { if (fine.matches) show(link); }, opts);
        link.addEventListener('focus', () => show(link), opts);
        link.addEventListener('click', hide, opts);
      });
      header.addEventListener('pointerleave', () => { leaveTimer = setTimeout(hide, 120); }, opts);
      header.addEventListener('pointerenter', () => clearTimeout(leaveTimer), opts);
      header.addEventListener('focusout', () => { requestAnimationFrame(() => { if (!header.querySelector('.uni-nav')?.contains(document.activeElement)) hide(); }); }, opts);
      header.addEventListener('keydown', event => { if (event.key === 'Escape') hide(); }, opts);
      window.addEventListener('scroll', hide, { ...opts, passive: true });
      window.addEventListener('resize', hide, { ...opts, passive: true });
      instances.set(header, () => { hide(); abort.abort(); });
    });
  }
  const key = 'unisystem:program-transition:v1';
  let outgoing = null;
  const settledReveals = new Map();
  const clearNames = () => {
    document.querySelectorAll('[data-uni-transition-active]').forEach(element => { element.style.removeProperty('view-transition-name'); delete element.dataset.uniTransitionActive; });
    settledReveals.forEach((styles, element) => {
      styles.forEach(({ name, value, priority }) => { if (value) element.style.setProperty(name, value, priority); else element.style.removeProperty(name); });
    });
    settledReveals.clear();
  };
  const settleIncomingReveal = (element, root) => {
    let reveal = element?.closest('.uni-reveal');
    while (reveal && root.contains(reveal)) {
      if (!settledReveals.has(reveal)) {
        const names = ['transition', 'opacity', 'transform'];
        settledReveals.set(reveal, names.map(name => ({ name, value: reveal.style.getPropertyValue(name), priority: reveal.style.getPropertyPriority(name) })));
        reveal.style.setProperty('transition', 'none', 'important');
        reveal.style.setProperty('opacity', '1', 'important');
        reveal.style.setProperty('transform', 'none', 'important');
        reveal.classList.remove('is-pending');
        reveal.classList.add('is-visible', 'uni-motion-settled');
      }
      reveal = reveal.parentElement?.closest('.uni-reveal');
    }
  };
  const nameElements = root => {
    if (!root || root.matches('uni-program[data-motion="none"]')) return false;
    const image = root.querySelector('[data-program-transition-image]'), title = root.querySelector('[data-program-transition-title]');
    [[image, 'uni-program-media'], [title, 'uni-program-title']].forEach(([element, name]) => {
      if (!element) return;
      if (root.matches('uni-program')) settleIncomingReveal(element, root);
      element.style.viewTransitionName = name; element.dataset.uniTransitionActive = 'true';
    });
    return Boolean(image || title);
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('a[data-program-link]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank' || !motion()) return;
    const card = link.closest('[data-program-card]');
    if (!card) return;
    try {
      const url = new URL(link.href);
      if (url.origin !== location.origin || url.pathname === location.pathname) return;
      outgoing = { id: card.dataset.programTransitionKey, path: url.pathname, createdAt: Date.now() };
      sessionStorage.setItem(key, JSON.stringify(outgoing));
      clearNames(); nameElements(card);
    } catch { outgoing = null; }
  });
  window.addEventListener('pageswap', event => {
    const transition = event.viewTransition;
    if (!transition) return;
    let destination;
    try { destination = new URL(event.activation?.entry?.url).pathname; } catch {}
    if (!motion() || !outgoing || outgoing.path !== destination) { transition.skipTransition(); clearNames(); return; }
    transition.finished.finally(clearNames).catch(() => {});
  });
  window.addEventListener('pagereveal', event => {
    if (!event.viewTransition) return;
    let saved;
    try { saved = JSON.parse(sessionStorage.getItem(key) || 'null'); sessionStorage.removeItem(key); } catch {}
    const program = document.querySelector('uni-program[data-program-transition-key]');
    const valid = saved && Number.isFinite(saved.createdAt) && Date.now() - saved.createdAt < 30000 && saved.createdAt <= Date.now() + 1000 && saved.path === location.pathname && saved.id === program?.dataset.programTransitionKey;
    if (!motion() || !valid || !nameElements(program)) { event.viewTransition.skipTransition(); clearNames(); return; }
    event.viewTransition.finished.finally(clearNames).catch(() => {});
  });
  window.addEventListener('pageshow', event => { if (event.persisted) { clearNames(); outgoing = null; } });
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => { instances.forEach((cleanup, header) => { if (event.target.contains(header)) { cleanup(); instances.delete(header); } }); });
})();
